import { render, staticRenderFns } from "./formRegistration.vue?vue&type=template&id=11c33b1b&scoped=true"
import script from "./formRegistration.vue?vue&type=script&lang=js"
export * from "./formRegistration.vue?vue&type=script&lang=js"
import style0 from "./formRegistration.vue?vue&type=style&index=0&id=11c33b1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c33b1b",
  null
  
)

export default component.exports